'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _FileCopy = _interopRequireDefault(require("@material-ui/icons/FileCopy"));
var _CandidateCountByStatus = _interopRequireDefault(require("Components/Charts/CandidateCountByStatus"));
var _CandidateCountBySupportStatus = _interopRequireDefault(require("Components/Charts/CandidateCountBySupportStatus"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _styles = require("@material-ui/core/styles");
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _DeleteCandidateModal = _interopRequireDefault(require("Modals/DeleteCandidateModal"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _options = _interopRequireDefault(require("Shared/options"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _options2 = require("../../../../FullStack/Shared/options");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_moment.default.locale('fr');
let app = window.app;
const department_default_options = [{
  value: 'all',
  label: 'Tous'
}];
const sectors_default_options = [{
  value: 'all',
  label: 'Tous les secteurs'
}];
const users_default_options = [{
  value: 'all',
  label: 'Tous'
}];
const support_default_options = [{
  value: 'all',
  label: 'Tous'
}];
const professional_domains_default_options = [{
  value: 'all',
  label: 'Tous'
}];
const CustomTab = (0, _styles.withStyles)(theme => ({
  root: {
    padding: 0,
    minWidth: 'auto',
    fontSize: '0.9em'
  }
}))(props => /*#__PURE__*/_react.default.createElement(_Tab.default, props));
const rqth_options = [{
  value: 'all',
  label: 'Tous'
}, {
  value: 'Oui',
  label: 'Oui'
}, {
  value: 'Non',
  label: 'Non'
}, {
  value: 'Demande en cours',
  label: 'Demande en cours'
}];
const monitoring_type_default_options = [{
  value: 'all',
  label: 'Tous'
}];
const dispositif_default_options = [{
  value: 'all',
  label: 'Tous'
}];
const account_status_options = [{
  value: 'all',
  label: 'Tous'
}];
const diagnostic_options = [{
  value: 'all',
  label: 'Tous'
}, {
  value: 'Diagnostiqué',
  label: 'Diagnostiqué'
}, {
  value: 'Non diagnostiqué',
  label: 'Non diagnostiqué'
}];
class Candidates extends _react.Component {
  state = {
    selected: [],
    candidates: [],
    candidates_count: 0,
    current_tab: 0,
    openSnackBar: false,
    page: 0,
    rows_per_page: 8,
    order: 'desc',
    order_by: 'created_at',
    searched_name: '',
    rqth_filter: 'all',
    monitoring_type_filter: 'all',
    dispositif_filter: 'all',
    account_status_filter: 'all',
    diagnostic_filter: 'all',
    support_filter: 'all',
    user_filter: localStorage.getItem('user_filter') || 'all',
    professional_domain_filter: 'all',
    department_filter: 'all',
    department_default_options: department_default_options,
    openDeleteCandidateModal: false,
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (app.state.session?.user?.id) {
      component.setSectorInState();
    }
    app.push({
      event: 'sessionChange',
      cb: component.setSectorInState
    });
    component.fetchDepartment();
    component.fetchProfessionalDomain();
    component.fetchUser();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.setSectorInState
    });
  }
  fetchCandidates = _ref => {
    let {
      page,
      order,
      order_by,
      sectors_filter,
      searched_name,
      rqth_filter,
      monitoring_type_filter,
      dispositif_filter,
      account_status_filter,
      support_filter,
      user_filter,
      professional_domain_filter,
      diagnostic_filter,
      searched_department
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-all', {
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      order: order,
      order_by: order_by,
      rqth_filter: rqth_filter || state.rqth_filter,
      sectors_filter: sectors_filter || state.sectors_filter,
      monitoring_type_filter: monitoring_type_filter || state.monitoring_type_filter,
      account_status_filter: account_status_filter || state.account_status_filter,
      support_filter: support_filter || state.support_filter,
      user_filter: user_filter || state.user_filter,
      professional_domain_filter: professional_domain_filter || state.professional_domain_filter,
      searched_name: searched_name || state.searched_name,
      diagnostic_filter: diagnostic_filter || state.diagnostic_filter,
      dispositif_filter: dispositif_filter || state.dispositif_filter,
      searched_department: searched_department || state.searched_department
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        candidates: response.candidates,
        candidates_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchSectors = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/sector/get-all').then(function (xhr, response) {
      component.setState({
        sectors: response.sectors || [],
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchProfessionalDomain = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/professional-domain/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        professional_domains: response.professional_domains || []
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchDepartment = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post(`/candidate/get-all-departments`).then((xhr, response) => {
      response.departments.map(department => {
        let option = {
          label: department,
          value: department
        };
        department_default_options.push(option);
      });
      component.setState({
        department_key: (0, _uniqid.default)()
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleDepChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const value = event.value;
    const name = event.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    component.fetchDepartment(event.value);
  };
  fetchUser = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/user/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        users: response.users
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  openDeleteCandidateModal = _ref2 => {
    let {
      candidate_id,
      e
    } = _ref2;
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteCandidateModal: true,
      delete_modal_candidate: candidate_id,
      delete_modal_trigger: e.target
    });
  };
  closeDeleteCandidateModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteCandidateModal: false,
      delete_modal_candidate: undefined,
      delete_modal_trigger: undefined
    });
    component.fetchCandidates({});
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchCandidates({
      page: page
    });
  };
  handleFilterChange = _ref3 => {
    let {
      e,
      value,
      name
    } = _ref3;
    const component = this,
      props = this.props,
      state = this.state;
    if (e === null) return;
    component.setState({
      [name]: value
    });
    component.fetchCandidates({
      [name]: value
    });
  };
  handleRequestSort = (e, column) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    const order_by = column.id;
    let order = 'desc';
    if (state.order_by === order_by && state.order === 'desc') {
      order = 'asc';
    }
    component.setState({
      order: order,
      order_by: order_by,
      loading: true
    });
    component.fetchCandidates({
      order: order,
      order_by: order_by
    });
  };
  handleSearchChange = _ref4 => {
    let {
      e,
      value,
      name
    } = _ref4;
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      searched_name: value
    });
    if (component.timeout) window.clearTimeout(component.timeout);
    component.timeout = window.setTimeout(function () {
      component.timeout = undefined;
      component.fetchCandidates({
        searched_name: value
      });
    }, 800);
  };
  handleDepartmentChange = value => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      searched_department: value
    });
    if (component.timeout) window.clearTimeout(component.timeout);
    component.timeout = window.setTimeout(function () {
      component.timeout = undefined;
      component.fetchCandidates({
        searched_department: value
      });
    }, 800);
  };
  getStatusLabel = status => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_label;
    switch (status) {
      case 'refused':
        status_label = 'Non accepté';
        break;
      case 'waiting':
        status_label = 'En attente';
        break;
      case 'accepted':
        status_label = 'Accepté';
        break;
      case 'unsubscribe':
        status_label = 'Désinscrit';
        break;
      default:
        '';
    }
    return status_label;
  };
  setSectorInState = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const roles = app.state.session?.user?.roles || [];
    if (roles.includes('agent')) {
      const user_sector = app.state.session.user.sector;
      component.setState({
        sectors_filter: user_sector || 'all'
      });
      component.fetchCandidates({
        sectors_filter: user_sector || 'all'
      });
    } else {
      component.setState({
        sectors_filter: 'all'
      });
      component.fetchCandidates({
        sectors_filter: 'all'
      });
    }
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleCloseSnackBar = (event, reason) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (reason === 'clickaway') {
      return;
    }
    component.setState({
      openSnackBar: false
    });
  };
  getTutorName = tutor_id => {
    const component = this,
      props = this.props,
      state = this.state;
    let tutor = (state.users || []).find(user => user.id === tutor_id);
    if (tutor) {
      return tutor?.lastname + ' ' + tutor?.firstname;
    } else {
      return 'Non renseigné';
    }
  };
  handleCopy = email => {
    const component = this,
      props = this.props,
      state = this.state;
    navigator.clipboard.writeText(email);
    component.setState({
      openSnackBar: true
    });
  };
  getProfessionalDomainLabel = professional_domain_id => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.professional_domains) return;
    let professional_domain = state.professional_domains.find(professional_domain => professional_domain.id === professional_domain_id);
    return professional_domain?.label || "";
  };
  handleFilterSessionChange = _ref5 => {
    let {
      e,
      value,
      name
    } = _ref5;
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      [name]: value
    });
    localStorage.setItem(name, value);
    component.fetchCandidates({
      [name]: value
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const user_roles = app.state.session?.user?.roles;
    const empty_rows = state.rows_per_page - Math.min(state.rows, state.candidates_count - state.page * state.rows_per_page);
    _moment.default.locale('fr');
    let professional_domains_options = (state.professional_domains || []).sort(function (a, b) {
      let labelA = a.label.toLowerCase(),
        labelB = b.label.toLowerCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    }).map(function (professional_domain) {
      let option = {
        label: professional_domain.label,
        value: professional_domain.id
      };
      return option;
    });
    const rows = (state.candidates || []).map(function (data) {
      const link = /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: '/liste-des-candidats/' + data.id,
        className: "u-link-only"
      });
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: data.id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, (0, _moment.default)(data.created_at).format('DD/MM/YYYY'), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, component.getTutorName(data.tutor), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.lastname, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.firstname, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.dispositif, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, component.getProfessionalDomainLabel(data.professional_domain), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.support, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.monitoring_type, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.login, /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.handleCopy(data.login)
      }, /*#__PURE__*/_react.default.createElement(_FileCopy.default, {
        color: "secondary"
      }))), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.phone_number !== "" ? data.phone_number : data.home_phone_number, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.rqth?.status, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, component.getStatusLabel(data.account_status), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.interested_companies.length || 0, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, user_roles.includes('admin') ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.openDeleteCandidateModal({
          candidate_id: data.id,
          e: e
        })
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
        color: "secondary"
      })) : undefined));
      return output;
    });
    const columns = [{
      id: 'created_at',
      numeric: false,
      label: 'Date de création',
      center: true
    }, {
      id: 'tutor',
      sortable: false,
      numeric: false,
      label: 'Job Coach',
      center: true
    }, {
      id: 'lastname',
      sortable: false,
      numeric: false,
      label: 'Nom',
      center: true
    }, {
      id: 'firstname',
      sortable: false,
      numeric: false,
      label: 'Prénom',
      center: true
    }, {
      id: 'dispositif',
      sortable: false,
      numeric: false,
      label: 'Dispositif',
      center: true
    }, {
      id: 'professional_domain',
      sortable: false,
      numeric: false,
      label: 'Domaine professionnel',
      center: true
    }, {
      id: 'support',
      sortable: false,
      numeric: false,
      label: 'Statut de l\'accompagnement',
      center: true
    }, {
      id: 'monitoring_type',
      sortable: false,
      numeric: false,
      label: 'Type d\'accompagnement',
      center: true
    }, {
      id: 'login',
      sortable: false,
      numeric: false,
      label: 'E-mail',
      center: true
    }, {
      id: 'phone_number',
      sortable: false,
      numeric: false,
      label: 'Numéro de téléphone',
      center: true
    }, {
      id: 'rqth',
      sortable: false,
      numeric: false,
      label: 'RQTH',
      center: true
    }, {
      id: 'account_status',
      sortable: false,
      numeric: false,
      label: 'Statut du compte',
      center: true
    }, {
      id: 'interested_companies',
      sortable: false,
      numeric: false,
      label: 'Entreprise(s) intéressée(s)',
      center: true
    }, {
      id: 'actions',
      sortable: false,
      numeric: false,
      label: '',
      center: true
    }];
    const sector_options = (state.sectors || []).map(function (sector) {
      let option = {
        label: sector.name,
        value: sector.id
      };
      return option;
    });
    const user_options = (state.users || []).map(function (user) {
      let option = {
        label: user.lastname + ' ' + user.firstname,
        value: user.id
      };
      return option;
    });
    user_options.sort((a, b) => {
      const nameA = a.label;
      const nameB = b.label;
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    const filter = state.sectors ? /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.sectors_filter,
      className: "u-padding-10",
      name: "sectors_filter",
      status: state.status_messages,
      options: sectors_default_options.concat(sector_options),
      "default-value": sectors_default_options[0].value,
      label: "Secteur AEAA"
    }) : undefined;
    const user_filter = state.users ? /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterSessionChange,
      value: state.user_filter,
      className: "u-padding-10",
      name: "user_filter",
      status: state.status_messages,
      options: users_default_options.concat(user_options),
      "default-value": users_default_options[0].value,
      label: "Job Coach"
    }) : undefined;
    const professional_domains_filter = state.professional_domains ? /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.professional_domain_filter,
      className: "u-padding-10",
      name: "professional_domain_filter",
      status: state.status_messages,
      options: professional_domains_default_options.concat(professional_domains_options),
      "default-value": professional_domains_default_options[0].value,
      label: "Domaine professionnel"
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "dashboard-table u-margin-bottom-10"
    }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
      value: state.current_tab,
      onChange: component.handleTabChange,
      name: "current_tab",
      variant: "scrollable",
      scrollButtons: "auto",
      indicatorColor: "primary",
      textColor: "primary"
    }, /*#__PURE__*/_react.default.createElement(CustomTab, {
      label: "Candidats",
      value: 0
    }), /*#__PURE__*/_react.default.createElement(CustomTab, {
      label: "Statistiques",
      value: 1
    }))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "dashboard-table",
      hidden: state.current_tab !== 0
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-filter"
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleSearchChange,
      className: "u-padding-10 u-full-width",
      name: "searched_name",
      label: "Nom recherch\xE9",
      status: state.status_messages,
      value: state.searched_name
    }), user_roles.includes('admin') ? user_filter : undefined, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.support_filter,
      className: "u-padding-10",
      name: "support_filter",
      status: state.status_messages,
      options: support_default_options.concat(_options.default.support_options),
      "default-value": support_default_options[0].value,
      label: "Statut de l'accompagnement"
    }), /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.monitoring_type_filter,
      className: "u-padding-10",
      name: "monitoring_type_filter",
      status: state.status_messages,
      options: monitoring_type_default_options.concat(_options.default.monitoring_type_options),
      "default-value": monitoring_type_default_options.concat(_options.default.monitoring_type_options)[0].value,
      label: "Objectif de l'accompagnement"
    }), /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.dispositif_filter,
      className: "u-padding-10",
      name: "dispositif_filter",
      status: state.status_messages,
      options: dispositif_default_options.concat(_options2.options_dispositif),
      "default-value": dispositif_default_options.concat(_options2.options_dispositif)[0].value,
      label: "Dispositif"
    }), /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.rqth_filter,
      className: "u-padding-10",
      name: "rqth_filter",
      status: state.status_messages,
      options: rqth_options,
      "default-value": rqth_options[0].value,
      label: "RQTH"
    }), /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.diagnostic_filter,
      className: "u-padding-10",
      name: "diagnostic_filter",
      status: state.status_messages,
      options: diagnostic_options,
      "default-value": diagnostic_options[0].value,
      label: "Diagnostic"
    }), /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.account_status_filter,
      className: "u-padding-10",
      name: "account_status_filter",
      status: state.status_messages,
      options: account_status_options.concat(_options.default.account_status_options),
      "default-value": account_status_options.concat(_options.default.account_status_options)[0].value,
      label: "Statut du compte"
    }), professional_domains_filter, user_roles.includes('admin') ? filter : undefined, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.searched_department,
      className: "u-padding-10",
      name: "searched_department",
      status: state.status_messages,
      key: state.department_key,
      options: department_default_options,
      "default-value": department_default_options[0].value,
      label: "D\xE9partement"
    })), /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Candidats"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: component.handleRequestSort,
      order: state.order,
      order_by: state.order_by,
      row_count: rows.length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, rows, empty_rows > 0 ? /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      style: {
        height: 49 * empty_rows
      }
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      colSpan: 4
    })) : undefined)), /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
      onChangePage: component.handleChangePage,
      component: "div",
      count: state.candidates_count,
      rowsPerPage: state.rows_per_page,
      rowsPerPageOptions: [],
      page: state.page,
      backIconButtonProps: {
        'aria-label': 'Page précédente'
      },
      nextIconButtonProps: {
        'aria-label': 'Page suivante'
      },
      labelDisplayedRows: _ref6 => {
        let {
          from,
          to,
          count
        } = _ref6;
        return from + '-' + to + ' sur ' + count;
      }
    }), /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
      open: state.openSnackBar,
      autoHideDuration: 1500,
      onClose: component.handleCloseSnackBar
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-snackbar"
    }, "Email copi\xE9")), /*#__PURE__*/_react.default.createElement(_DeleteCandidateModal.default, {
      candidate_to_delete: state.delete_modal_candidate,
      open: state.openDeleteCandidateModal,
      onClose: component.closeDeleteCandidateModal,
      delete_modal_trigger: state.delete_modal_trigger
    }), user_roles.includes('admin') ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      href: "/telechargements/candidat",
      className: "custom-export-button",
      target: "_blank",
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props),
      status: state.status_messages
    }, "Exporter tous les candidats  en xls") : undefined, user_roles.includes('admin') ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      href: "/telechargements/candidat?sector_filter=" + (state.sectors_filter || "all") + '&rqth_filter=' + (state.rqth_filter || "all") + '&monitoring_type_filter=' + (state.monitoring_type_filter || "all") + '&account_status_filter=' + (state.account_status_filter || "all") + '&support_filter=' + (state.support_filter || "all") + '&professional_domain_filter=' + (state.professional_domain_filter || "all") + '&diagnostic_filter=' + (state.diagnostic_filter || "all") + '&user_filter=' + (state.user_filter || "all"),
      className: "custom-export-button",
      target: "_blank",
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props),
      status: state.status_messages
    }, "Exporter les candidats en xls (Avec filtre)") : undefined), state.current_tab === 1 ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_CandidateCountByStatus.default, null), /*#__PURE__*/_react.default.createElement(_CandidateCountBySupportStatus.default, {
      className: "u-margin-top-10"
    })) : undefined);
    return output;
  }
}
exports.default = Candidates;
